module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/app-download-googleplay-236594b64780ab19e3929c88fb30613a.png";